import LineItem from "./line-item.js";

class Checkout {
  constructor(siteName) {
    this.siteName = siteName;
    this.lineItems = [];
    this.currentStep = 0;
    // TODO intialize all values for data binding
    this.data = {

    };
  }

  load(results) {
    this.config = results[0].data;
    this.product = results[1].data;
    console.log(this.config);
    console.log(this.product);
    // construct line items
    // TODO for now any change in line item will not be reflected back to plan quantity and addons
    this.data["shipping.ship.to.billing"] = this.addressInfo().ship_to_my_billing_address || false;
    // this.data["shipping.ship.to.billing"] = false;
    LineItem.constructItems(this);
  }

  static get OTHER_ADDRESS_FIELDS() {
    return [
      'first_name',
      'last_name',
      'email',
      'phone',
      'company'
    ]
  }

  static get ACCOUNT_INFO_ORDER() {
    return [
      'customer[first_name]',
      'customer[last_name]',
      'customer[email]',
      'customer[company]',
      'customer[phone]'
    ]
  }

  static get CARD_ADDRESS_FIELDS() {
    return [
      "card[billing_addr1]",
      "card[billing_addr2]",
      "card[billing_city]",
      "card[billing_country]",
      "card[billing_state]",
      "card[billing_state_code]",
      "card[billing_zip]",
      "card.billing_region"
    ]
  }

  canShowAccountInfo() {
    return this.accountInfo().fields.length > 0;
  }

  canShowAddress() {
    return this.addressInfo().fields.length > 0;
  }

  canShowCardInfo() {
    return this.cardInfo().fields.length > 0;
  }

  canShowSubscriptionInfo() {
    return this.subscriptionInfo().fields.length > 0;
  }

  accountInfo() {
    return this.config.sections.filter(section => section.type == "account")[0];
  }

  addressInfo() {
    return this.config.sections.filter(section => section.type == "address")[0] 
  }

  cardInfo() {
    return this.config.sections.filter(section => section.type == "payment")[0] 
  }

  subscriptionInfo() {
    return this.config.sections.filter(section => section.type == "subscription")[0] 
  }

  // Address fields are state, address, zip, county
  billingInfoWithoutAddressFields() {
    return this.billingInfoFields().filter(field => Checkout.OTHER_ADDRESS_FIELDS.filter(f => field.id.endsWith(f)).length > 0);
  }

  billingInfoOnlyAddressFields() {
    return this.billingInfoFields().filter(field => !(Checkout.OTHER_ADDRESS_FIELDS.filter(f => field.id.endsWith(f)).length > 0));
  }

  billingInfoFields() {
    return this.addressInfo().fields.filter(field => field.name.startsWith("billing"));
  }

  // Address fields are state, address, zip, county
  shippingInfoWithoutAddressFields() {
    return this.shippingInfoFields().filter(field => Checkout.OTHER_ADDRESS_FIELDS.filter(f => field.id.endsWith(f)).length > 0);
  }

  shippingInfoOnlyAddressFields() {
    var fields = this.shippingInfoFields().filter(field => !(Checkout.OTHER_ADDRESS_FIELDS.filter(f => field.id.endsWith(f)).length > 0));
    return fields.filter(field => field.id != "shipping.ship.to.billing");
  }

  shippingInfoFields() {
    return this.addressInfo().fields.filter(field => field.name.startsWith("shipping"));
  }

  accountInfoFieldsForDisplay() {
    var tmpMap = this.accountInfo().fields.reduce((map, value) => {
      map[value.name] = value;
      return map;
    },{});
    var remaining = this.accountInfo().fields.filter(f => Checkout.ACCOUNT_INFO_ORDER.indexOf(f.name) == -1);
    var output = Checkout.ACCOUNT_INFO_ORDER.map(f =>  tmpMap[f]).filter(v => !!v);
    return output.concat(remaining);
  }

  cardInfoAddressFields() {
    return this.cardInfo().fields.filter(field => Checkout.CARD_ADDRESS_FIELDS.filter(f => field.name == f).length > 0);
  }

  itemsWithoutDiscounts() {
    return this.lineItems.filter(l => l.type == "plan" || l.type == "addon");
  }

  totalAmount() {
    return this.lineItems[0].currencySymbol + this.totalAmountWithoutSymbol().toFixed(2);
  }

  totalAmountWithoutSymbol() {
    return this.itemsWithoutDiscounts().map(item => item.getAmount()).reduce( ( acc, cur ) => acc + cur, 0 );
  }

  finalAmount() {
    return this.lineItems[0].currencySymbol + (this.totalAmountWithoutSymbol() - this.discounts()).toFixed(2);
  }

  discountItems() {
    return this.lineItems.filter(l => l.type == "discount");
  }

  discounts() {
    return this.discountItems().map(i => parseFloat(i.unitPrice) ).reduce( ( acc, cur ) => acc + cur, 0 );
  }

  discountsWithSymbol() {
    return this.lineItems[0].currencySymbol + this.discounts();
  }

  applyCoupon(couponCode) {
    var lineItem = new LineItem();
    lineItem["type"] = "discount";
    lineItem["unitPrice"] = (this.totalAmountWithoutSymbol() / 10).toFixed(2);
    lineItem["name"] = "Flat discount";
    this.lineItems.push(lineItem);
  }
}

export default Checkout;


// WEBPACK FOOTER //
// ./src/models/checkout.js